<div class="draft-notice" *ngIf="show">
  <span class="draft-notice-message">You have not submitted the Declaration form. Please submit now.</span>
  <button type="button" class="draft-notice-close" aria-label="Close" (click)="onClose()">&times;</button>
</div>
